export default __webpack_public_path__ + "static/media/closeMark.8c36675e.svg";